// extracted by mini-css-extract-plugin
export default {"fileRankLabel":"TileLayer_mobile_fileRankLabel__ycXGW","tileLayer":"TileLayer_mobile_tileLayer__MeGJD"};